/* =========================================================
  GLUCK GIFT DIAGNOSIS PRODUCT DATA
  Updated: 2026-10-07
========================================================= */

window.GLK_GIFT_DIAGNOSIS_DATA = {
  "version": 3,

  "heroImages": {
    "active": {
      "male": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-active_male.png?v=1789711826",
      "female": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-active_female.png?v=1789711826"
    },

    "minimal": {
      "male": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-minimal_male.png?v=1789711826",
      "female": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-minimal_female.png?v=1789711826"
    },

    "casual": {
      "male": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-casual_male.png?v=1789711826",
      "female": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-casual_female.png?v=1789711826"
    },

    "mode": {
      "male": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-mode_male.png?v=1789711826",
      "female": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-mode_female.png?v=1789711826"
    },

    "elegant": {
      "male": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-elegant_male.png?v=1789711826",
      "female": "https://cdn.shopify.com/s/files/1/0879/0556/7010/files/gift-elegant_female.png?v=1789711826"
    }
  },


  "products": {

    "sonne-coin-necklace": {
      "name": "Sonne Coin necklace",
      "category": "NECKLACE"
    },

    "plate-necklace-snd": {
      "name": "Plate Necklace SND",
      "category": "NECKLACE"
    },

    "bar-necklace": {
      "name": "Bar Necklace",
      "category": "NECKLACE"
    },

    "coin-necklace-spd": {
      "name": "Coin necklace SPD",
      "category": "NECKLACE"
    },

    "motel-key-necklace": {
      "name": "Motel Key Necklace",
      "category": "NECKLACE"
    },

    "double-cross-necklace": {
      "name": "Double cross necklace",
      "category": "NECKLACE"
    },

    "horseshoe-necklace": {
      "name": "Horseshoe Necklace",
      "category": "NECKLACE"
    },

    "cable-chain-bracelet": {
      "name": "Cable chain bracelet",
      "category": "BRACELET"
    },

    "anchor-chain-bracelet": {
      "name": "Anchor Chain Bracelet",
      "category": "BRACELET"
    },

    "coin-chain-bracelet": {
      "name": "Coin chain bracelet",
      "category": "BRACELET"
    },

    "twist-bangle": {
      "name": "Twist bangle",
      "category": "BRACELET"
    },

    "cable-chain-bracelet-ii": {
      "name": "Cable chain bracelet II",
      "category": "BRACELET"
    },

    "craft-bangle": {
      "name": "Craft bangle",
      "category": "BRACELET"
    },

    "hufeisen-chain-bracelet": {
      "name": "Hufeisen chain bracelet",
      "category": "BRACELET"
    },

    "drei-ring": {
      "name": "Drei ring",
      "category": "RING"
    },

    "stone-ring": {
      "name": "Stone ring",
      "category": "RING"
    },

    "double-kihei-ring": {
      "name": "Double kihei ring",
      "category": "RING"
    },

    "round-signet-ring": {
      "name": "Round signet ring",
      "category": "RING"
    },

    "verformung-ring": {
      "name": "Verformung ring",
      "category": "RING"
    },

    "flow-ring": {
      "name": "Flow ring",
      "category": "RING"
    },

    "cut-design-ring": {
      "name": "Cut design ring",
      "category": "RING"
    },

    "schneiden-pierce": {
      "name": "Schneiden pierce",
      "category": "PIERCE"
    },

    "line-ear-cuff": {
      "name": "Line Ear Cuff",
      "category": "EAR CUFF"
    },

    "stud-pierce": {
      "name": "Stud Pierce",
      "category": "PIERCE"
    },

    "code-ear-cuff": {
      "name": "Code Ear Cuff",
      "category": "EAR CUFF"
    },

    "chain-pierce": {
      "name": "Chain Pierce",
      "category": "PIERCE"
    },

    "twist-pierce": {
      "name": "Twist pierce",
      "category": "PIERCE"
    },

    "layered-ear-cuff": {
      "name": "Layered ear cuff",
      "category": "EAR CUFF"
    },

    "mini-horseshoe-necklace": {
      "name": "Mini Horseshoe Necklace",
      "category": "NECKLACE"
    },

    "double-ring-necklace": {
      "name": "Double ring necklace",
      "category": "NECKLACE"
    },

    "licht-necklace": {
      "name": "Licht necklace",
      "category": "NECKLACE"
    },

    "unite-bracelet": {
      "name": "Unite bracelet",
      "category": "BRACELET"
    },

    "glitter-ring": {
      "name": "Glitter Ring",
      "category": "RING"
    },

    "knot-pierce": {
      "name": "Knot pierce",
      "category": "PIERCE"
    },

    "rolo-chain-necklace": {
      "name": "Rolo chain necklace",
      "category": "NECKLACE"
    },

    "snake-necklace-3mm": {
      "name": "Snake necklace 3mm",
      "category": "NECKLACE"
    },

    "chain-necklace-3-5mm": {
      "name": "Chain necklace 3.5mm",
      "category": "NECKLACE"
    },

    "round-snake-necklace": {
      "name": "Round snake necklace",
      "category": "NECKLACE"
    },

    "eternal-necklace": {
      "name": "Eternal Necklace",
      "category": "NECKLACE"
    },

    "chain-bracelet": {
      "name": "Chain bracelet",
      "category": "BRACELET"
    },

    "einfach-bangle": {
      "name": "Einfach bangle",
      "category": "BRACELET"
    },

    "plate-chain-bracelet": {
      "name": "Plate chain bracelet",
      "category": "BRACELET"
    },

    "einfach-ring-2mm": {
      "name": "Einfach ring 2mm",
      "category": "RING"
    },

    "link-ring": {
      "name": "Link ring",
      "category": "RING"
    },

    "knot-ring": {
      "name": "Knot ring",
      "category": "RING"
    },

    "einfach-ring-4mm": {
      "name": "Einfach ring 4mm",
      "category": "RING"
    },

    "duo-ring": {
      "name": "Duo ring",
      "category": "RING"
    },

    "nuance-ring": {
      "name": "Nuance ring",
      "category": "RING"
    },

    "simple-ear-cuff": {
      "name": "Simple ear cuff",
      "category": "EAR CUFF"
    },

    "hoop-pierce": {
      "name": "Hoop pierce",
      "category": "PIERCE"
    },

    "luminous-pierce": {
      "name": "Luminous pierce",
      "category": "PIERCE"
    },

    "drop-ear-cuff": {
      "name": "Drop ear cuff",
      "category": "EAR CUFF"
    },

    "round-necklace": {
      "name": "Round Necklace",
      "category": "NECKLACE"
    },

    "box-bracelet": {
      "name": "Box bracelet",
      "category": "BRACELET"
    },

    "twinkle-necklace": {
      "name": "Twinkle necklace",
      "category": "NECKLACE"
    },

    "zirconia-petal-necklace": {
      "name": "Zirconia × petal necklace",
      "category": "NECKLACE"
    },

    "layard-bracelet": {
      "name": "Layered Bracelet",
      "category": "BRACELET"
    },

    "petal-bracelet": {
      "name": "Petal bracelet",
      "category": "BRACELET"
    },

    "open-ring": {
      "name": "Open ring",
      "category": "RING"
    },

    "everlink-ring": {
      "name": "Everlink Ring",
      "category": "RING"
    },

    "twist-ring": {
      "name": "Twist ring",
      "category": "RING"
    },

    "flat-chain-bracelet": {
      "name": "Flat chain bracelet",
      "category": "BRACELET"
    },

    "horseshoe-necklace-s925": {
      "name": "Horseshoe Necklace S925",
      "category": "NECKLACE"
    },

    "round-snake-necklace-s925": {
      "name": "Round snake necklace S925",
      "category": "NECKLACE"
    },

    "bar-necklace-s925": {
      "name": "Bar Necklace S925",
      "category": "NECKLACE"
    },

    "anchor-bracelet-s925": {
      "name": "Anchor bracelet S925",
      "category": "BRACELET"
    },

    "design-ring-s925": {
      "name": "Design ring S925",
      "category": "RING"
    },

    "schneiden-pierce-s925": {
      "name": "Schneiden pierce S925",
      "category": "PIERCE"
    },

    "twist-pierce-s925": {
      "name": "Twist pierce S925",
      "category": "PIERCE"
    },

    "nuance-necklace": {
      "name": "Nuance necklace",
      "category": "NECKLACE"
    },

    "heart-necklace-s925": {
      "name": "Heart necklace S925",
      "category": "NECKLACE"
    },

    "wave-bracelet": {
      "name": "Wave bracelet",
      "category": "BRACELET"
    },

    "knot-ring-s925": {
      "name": "Knot ring S925",
      "category": "RING"
    },

    "twist-horseshoe-necklace-s925": {
      "name": "Twist Horseshoe Necklace S925",
      "category": "NECKLACE"
    },

    "kihei-ring-s925": {
      "name": "Kihei ring S925",
      "category": "RING"
    },

    "zirconia-necklace-ii": {
      "name": "Zirconia Necklace II",
      "category": "NECKLACE"
    },

    "ribbon-necklace-s925": {
      "name": "Ribbon necklace S925",
      "category": "NECKLACE"
    },

    "zirconia-ring": {
      "name": "Zirconia ring",
      "category": "RING"
    },

    "beiller-ring-s925": {
      "name": "Beiller ring S925",
      "category": "RING"
    },

    "petal-pierce": {
      "name": "Petal pierce",
      "category": "PIERCE"
    },

    "droop-pearl-pierce": {
      "name": "Droop pearl pierce",
      "category": "PIERCE"
    },

    "drop-pierce": {
      "name": "Drop pierce",
      "category": "PIERCE"
    },

    "moon-pierce-s925": {
      "name": "Moon pierce S925",
      "category": "PIERCE"
    },

    "box-chain-necklace": {
      "name": "Box chain necklace",
      "category": "NECKLACE"
    },

    "figaro-chain-necklace": {
      "name": "Figaro chain necklace",
      "category": "NECKLACE"
    }
  },


  "recommendations": {

    /* =======================================================
      ACTIVE
    ======================================================= */

    "active": {

      "male": {

        "necklace": {
          "bestMatch": "sonne-coin-necklace",

          "items": [
            "plate-necklace-snd",
            "bar-necklace",
            "coin-necklace-spd",
            "motel-key-necklace"
          ],

          "pickups": [
            "double-cross-necklace",
            "horseshoe-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "cable-chain-bracelet",

          "items": [
            "anchor-chain-bracelet",
            "coin-chain-bracelet",
            "twist-bangle",
            "cable-chain-bracelet-ii"
          ],

          "pickups": [
            "craft-bangle",
            "hufeisen-chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "drei-ring",

          "items": [
            "stone-ring",
            "double-kihei-ring",
            "round-signet-ring",
            "verformung-ring"
          ],

          "pickups": [
            "flow-ring",
            "cut-design-ring"
          ]
        },


        "ear": {
          "bestMatch": "schneiden-pierce",

          "items": [
            "line-ear-cuff",
            "stud-pierce",
            "code-ear-cuff",
            "chain-pierce"
          ],

          "pickups": [
            "twist-pierce",
            "layered-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "sonne-coin-necklace",

          "items": [
            "cable-chain-bracelet",
            "anchor-chain-bracelet",
            "twist-bangle",
            "plate-necklace-snd"
          ],

          "pickups": [
            "drei-ring",
            "schneiden-pierce"
          ]
        }
      },


      "female": {

        "necklace": {
          "bestMatch": "mini-horseshoe-necklace",

          "items": [
            "double-ring-necklace",
            "sonne-coin-necklace",
            "coin-necklace-spd",
            "licht-necklace"
          ],

          "pickups": [
            "bar-necklace",
            "motel-key-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "cable-chain-bracelet",

          "items": [
            "unite-bracelet",
            "twist-bangle",
            "coin-chain-bracelet",
            "craft-bangle"
          ],

          "pickups": [
            "anchor-chain-bracelet",
            "cable-chain-bracelet-ii"
          ]
        },


        "ring": {
          "bestMatch": "drei-ring",

          "items": [
            "stone-ring",
            "glitter-ring",
            "double-kihei-ring",
            "verformung-ring"
          ],

          "pickups": [
            "flow-ring",
            "cut-design-ring"
          ]
        },


        "ear": {
          "bestMatch": "schneiden-pierce",

          "items": [
            "knot-pierce",
            "line-ear-cuff",
            "twist-pierce",
            "chain-pierce"
          ],

          "pickups": [
            "code-ear-cuff",
            "layered-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "mini-horseshoe-necklace",

          "items": [
            "cable-chain-bracelet",
            "anchor-chain-bracelet",
            "twist-bangle",
            "double-ring-necklace"
          ],

          "pickups": [
            "drei-ring",
            "schneiden-pierce"
          ]
        }
      }
    },


    /* =======================================================
      MINIMAL
    ======================================================= */

    "minimal": {

      "male": {

        "necklace": {
          "bestMatch": "rolo-chain-necklace",

          "items": [
            "snake-necklace-3mm",
            "bar-necklace",
            "plate-necklace-snd",
            "chain-necklace-3-5mm"
          ],

          "pickups": [
            "round-snake-necklace",
            "eternal-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "twist-bangle",

          "items": [
            "anchor-chain-bracelet",
            "chain-bracelet",
            "einfach-bangle",
            "plate-chain-bracelet"
          ],

          "pickups": [
            "hufeisen-chain-bracelet",
            "cable-chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "einfach-ring-2mm",

          "items": [
            "link-ring",
            "knot-ring",
            "einfach-ring-4mm",
            "duo-ring"
          ],

          "pickups": [
            "nuance-ring",
            "round-signet-ring"
          ]
        },


        "ear": {
          "bestMatch": "line-ear-cuff",

          "items": [
            "simple-ear-cuff",
            "stud-pierce",
            "hoop-pierce",
            "luminous-pierce"
          ],

          "pickups": [
            "code-ear-cuff",
            "drop-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "rolo-chain-necklace",

          "items": [
            "round-necklace",
            "bar-necklace",
            "box-bracelet",
            "line-ear-cuff"
          ],

          "pickups": [
            "einfach-ring-2mm",
            "round-snake-necklace"
          ]
        }
      },


      "female": {

        "necklace": {
          "bestMatch": "bar-necklace",

          "items": [
            "twinkle-necklace",
            "snake-necklace-3mm",
            "mini-horseshoe-necklace",
            "round-necklace"
          ],

          "pickups": [
            "licht-necklace",
            "zirconia-petal-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "layard-bracelet",

          "items": [
            "petal-bracelet",
            "einfach-bangle",
            "chain-bracelet",
            "box-bracelet"
          ],

          "pickups": [
            "plate-chain-bracelet",
            "craft-bangle"
          ]
        },


        "ring": {
          "bestMatch": "einfach-ring-2mm",

          "items": [
            "flow-ring",
            "nuance-ring",
            "knot-ring",
            "cut-design-ring"
          ],

          "pickups": [
            "einfach-ring-4mm",
            "open-ring"
          ]
        },


        "ear": {
          "bestMatch": "line-ear-cuff",

          "items": [
            "simple-ear-cuff",
            "stud-pierce",
            "luminous-pierce",
            "drop-ear-cuff"
          ],

          "pickups": [
            "hoop-pierce",
            "code-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "bar-necklace",

          "items": [
            "snake-necklace-3mm",
            "round-snake-necklace",
            "box-bracelet",
            "line-ear-cuff"
          ],

          "pickups": [
            "einfach-ring-2mm",
            "mini-horseshoe-necklace"
          ]
        }
      }
    },


    /* =======================================================
      CASUAL
    ======================================================= */

    "casual": {

      "male": {

        "necklace": {
          "bestMatch": "horseshoe-necklace",

          "items": [
            "rolo-chain-necklace",
            "eternal-necklace",
            "chain-necklace-3-5mm",
            "round-necklace"
          ],

          "pickups": [
            "double-ring-necklace",
            "bar-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "craft-bangle",

          "items": [
            "cable-chain-bracelet",
            "box-bracelet",
            "plate-chain-bracelet",
            "chain-bracelet"
          ],

          "pickups": [
            "twist-bangle",
            "einfach-bangle"
          ]
        },


        "ring": {
          "bestMatch": "duo-ring",

          "items": [
            "drei-ring",
            "everlink-ring",
            "twist-ring",
            "nuance-ring"
          ],

          "pickups": [
            "stone-ring",
            "verformung-ring"
          ]
        },


        "ear": {
          "bestMatch": "line-ear-cuff",

          "items": [
            "hoop-pierce",
            "knot-pierce",
            "simple-ear-cuff",
            "stud-pierce"
          ],

          "pickups": [
            "schneiden-pierce",
            "code-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "horseshoe-necklace",

          "items": [
            "rolo-chain-necklace",
            "hufeisen-chain-bracelet",
            "box-bracelet",
            "stone-ring"
          ],

          "pickups": [
            "cable-chain-bracelet",
            "drei-ring"
          ]
        }
      },


      "female": {

        "necklace": {
          "bestMatch": "horseshoe-necklace",

          "items": [
            "sonne-coin-necklace",
            "mini-horseshoe-necklace",
            "snake-necklace-3mm",
            "round-necklace"
          ],

          "pickups": [
            "double-ring-necklace",
            "bar-necklace"
          ]
        },


        "bracelet": {
          "bestMatch": "layard-bracelet",

          "items": [
            "einfach-bangle",
            "box-bracelet",
            "cable-chain-bracelet",
            "chain-bracelet"
          ],

          "pickups": [
            "flat-chain-bracelet",
            "hufeisen-chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "nuance-ring",

          "items": [
            "knot-ring",
            "duo-ring",
            "twist-ring",
            "open-ring"
          ],

          "pickups": [
            "drei-ring",
            "stone-ring"
          ]
        },


        "ear": {
          "bestMatch": "line-ear-cuff",

          "items": [
            "hoop-pierce",
            "knot-pierce",
            "stud-pierce",
            "simple-ear-cuff"
          ],

          "pickups": [
            "schneiden-pierce",
            "drop-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "horseshoe-necklace",

          "items": [
            "rolo-chain-necklace",
            "layard-bracelet",
            "anchor-chain-bracelet",
            "drei-ring"
          ],

          "pickups": [
            "mini-horseshoe-necklace",
            "line-ear-cuff"
          ]
        }
      }
    },


    /* =======================================================
      MODE
    ======================================================= */

    "mode": {

      "male": {

        "necklace": {
          "bestMatch": "horseshoe-necklace-s925",

          "items": [
            "eternal-necklace",
            "licht-necklace",
            "double-cross-necklace",
            "double-ring-necklace"
          ],

          "pickups": [
            "round-snake-necklace-s925",
            "bar-necklace-s925"
          ]
        },


        "bracelet": {
          "bestMatch": "cable-chain-bracelet-ii",

          "items": [
            "anchor-bracelet-s925",
            "craft-bangle",
            "coin-chain-bracelet",
            "hufeisen-chain-bracelet"
          ],

          "pickups": [
            "twist-bangle",
            "anchor-chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "design-ring-s925",

          "items": [
            "flow-ring",
            "double-kihei-ring",
            "stone-ring",
            "drei-ring"
          ],

          "pickups": [
            "twist-ring",
            "verformung-ring"
          ]
        },


        "ear": {
          "bestMatch": "schneiden-pierce-s925",

          "items": [
            "chain-pierce",
            "code-ear-cuff",
            "layered-ear-cuff",
            "line-ear-cuff"
          ],

          "pickups": [
            "schneiden-pierce",
            "twist-pierce-s925"
          ]
        },


        "undecided": {
          "bestMatch": "horseshoe-necklace-s925",

          "items": [
            "anchor-bracelet-s925",
            "cable-chain-bracelet-ii",
            "twist-bangle",
            "verformung-ring"
          ],

          "pickups": [
            "bar-necklace-s925",
            "schneiden-pierce-s925"
          ]
        }
      },


      "female": {

        "necklace": {
          "bestMatch": "horseshoe-necklace-s925",

          "items": [
            "bar-necklace",
            "licht-necklace",
            "nuance-necklace",
            "double-ring-necklace"
          ],

          "pickups": [
            "bar-necklace-s925",
            "heart-necklace-s925"
          ]
        },


        "bracelet": {
          "bestMatch": "cable-chain-bracelet-ii",

          "items": [
            "twist-bangle",
            "craft-bangle",
            "wave-bracelet",
            "coin-chain-bracelet"
          ],

          "pickups": [
            "anchor-bracelet-s925",
            "layard-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "drei-ring",

          "items": [
            "flow-ring",
            "glitter-ring",
            "cut-design-ring",
            "knot-ring-s925"
          ],

          "pickups": [
            "twist-ring",
            "verformung-ring"
          ]
        },


        "ear": {
          "bestMatch": "schneiden-pierce-s925",

          "items": [
            "knot-pierce",
            "chain-pierce",
            "schneiden-pierce",
            "layered-ear-cuff"
          ],

          "pickups": [
            "code-ear-cuff",
            "twist-pierce"
          ]
        },


        "undecided": {
          "bestMatch": "bar-necklace-s925",

          "items": [
            "horseshoe-necklace",
            "anchor-bracelet-s925",
            "twist-bangle",
            "twist-pierce-s925"
          ],

          "pickups": [
            "knot-ring-s925",
            "schneiden-pierce-s925"
          ]
        }
      }
    },


    /* =======================================================
      ELEGANT
    ======================================================= */

    "elegant": {

      "male": {

        "necklace": {
          "bestMatch": "twist-horseshoe-necklace-s925",

          "items": [
            "double-ring-necklace",
            "round-necklace",
            "eternal-necklace",
            "bar-necklace"
          ],

          "pickups": [
            "horseshoe-necklace-s925",
            "bar-necklace-s925"
          ]
        },


        "bracelet": {
          "bestMatch": "anchor-bracelet-s925",

          "items": [
            "craft-bangle",
            "anchor-chain-bracelet",
            "plate-chain-bracelet",
            "box-bracelet"
          ],

          "pickups": [
            "twist-bangle",
            "chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "kihei-ring-s925",

          "items": [
            "duo-ring",
            "open-ring",
            "round-signet-ring",
            "stone-ring"
          ],

          "pickups": [
            "knot-ring-s925",
            "nuance-ring"
          ]
        },


        "ear": {
          "bestMatch": "schneiden-pierce-s925",

          "items": [
            "line-ear-cuff",
            "simple-ear-cuff",
            "drop-ear-cuff",
            "hoop-pierce"
          ],

          "pickups": [
            "stud-pierce",
            "schneiden-pierce"
          ]
        },


        "undecided": {
          "bestMatch": "twist-horseshoe-necklace-s925",

          "items": [
            "round-necklace",
            "anchor-chain-bracelet",
            "einfach-bangle",
            "stone-ring"
          ],

          "pickups": [
            "horseshoe-necklace-s925",
            "anchor-bracelet-s925"
          ]
        }
      },


      "female": {

        "necklace": {
          "bestMatch": "bar-necklace-s925",

          "items": [
            "zirconia-petal-necklace",
            "mini-horseshoe-necklace",
            "zirconia-necklace-ii",
            "licht-necklace"
          ],

          "pickups": [
            "ribbon-necklace-s925",
            "round-snake-necklace-s925"
          ]
        },


        "bracelet": {
          "bestMatch": "twist-bangle",

          "items": [
            "einfach-bangle",
            "wave-bracelet",
            "petal-bracelet",
            "layard-bracelet"
          ],

          "pickups": [
            "anchor-bracelet-s925",
            "chain-bracelet"
          ]
        },


        "ring": {
          "bestMatch": "knot-ring-s925",

          "items": [
            "drei-ring",
            "duo-ring",
            "zirconia-ring",
            "open-ring"
          ],

          "pickups": [
            "beiller-ring-s925",
            "nuance-ring"
          ]
        },


        "ear": {
          "bestMatch": "twist-pierce-s925",

          "items": [
            "stud-pierce",
            "petal-pierce",
            "droop-pearl-pierce",
            "line-ear-cuff"
          ],

          "pickups": [
            "drop-pierce",
            "simple-ear-cuff"
          ]
        },


        "undecided": {
          "bestMatch": "bar-necklace-s925",

          "items": [
            "mini-horseshoe-necklace",
            "layard-bracelet",
            "zirconia-necklace-ii",
            "drei-ring"
          ],

          "pickups": [
            "twist-pierce-s925",
            "anchor-bracelet-s925"
          ]
        }
      }
    }
  }
};